import Alpine from 'alpinejs'
import threeQLoader from './three-q-loader'

Alpine.data('videoPlayer', (
    videoId: string,
    videoKey: string,
    videoKeyTimestamp: number,
    videoOffset: number,
    videoEnd: number,
    subTitleLanguageCode: string|null,
    playbackUID: string,
    productId: string,
    videoHasSubtitles: boolean
) => ({

    player: null,
    state: 'uninitialized',
    playbackTracked: 0,
    playIntent: false,
    
    init() {
        this.$watch('state', value => {
            if(value === 'loaded' && this.playIntent) {
                this.playIntent = false
                this.load(true)
            }
        })
        threeQLoader().then(() => {
            this.state = 'loaded'
        })
    },

    load(play=false) {
        if(this.state === 'uninitialized') {
            return
        }
        this.player = new window.js3q({
            dataid: videoId,
            key: videoKey,
            timestamp: videoKeyTimestamp,
            container: 'product-video-player',
            autoplay: play,
            allowmutedautoplay: play,
            tintColor : '#B4146E',
            defaultCC : subTitleLanguageCode || ''
        })
        if(subTitleLanguageCode) {
            this.player.mute()
        }
        this.state = 'initialized'
        this.player.on('media.timeChange', (data) => this.onMediaTimeChange(data))
        this.player.on('media.playing', () => this.$dispatch('video-started'))
        this.player.on('media.paused', () => this.$dispatch('video-stopped'))
        this.player.on('media.complete', () => this.$dispatch('video-stopped'))
        this.player.on('media.muted', () => this.$dispatch('video-muted'))
        this.player.on('media.unmuted', () => this.$dispatch('video-unmuted'))
    },

    onDestroy() {
        if(!this.player) {
            return
        }
        this.player.destroy()
    },

    onMediaTimeChange(videoPositionSeconds) {
        this.seekBounds(videoPositionSeconds)
        this.trackProgress(videoPositionSeconds)
    },

    trackProgress(videoPositionSeconds) {
        const secondsPlayed = Math.max(0, videoPositionSeconds-videoOffset)
        if(secondsPlayed < this.playbackTracked+5) {
            return
        }
        this.playbackTracked = secondsPlayed - secondsPlayed % 5
        this.$dispatch('video-progress', {
            uid: playbackUID,
            secondsPlayed: this.playbackTracked,
            hasSubtitles: videoHasSubtitles
        })
    },

    seekBounds(videoPositionSeconds) {
        if(videoOffset <= 0) {
            return
        }
        if(videoPositionSeconds <= 0) {
            return
        }

        // seek to begin

        if(this.state === 'seekBegin') {
            this.state = 'seekingBegin'
            this.player.seek(videoOffset)
            return
        }
        if(this.state === 'seekingBegin' && videoPositionSeconds >= videoOffset) {
            this.state = 'ready'
            return
        }
        if(videoPositionSeconds < videoOffset) {
            this.state = 'seekBegin'
            this.player.play()
            return
        }

        // seek to end

        if(this.state === 'seekRewind') {
            this.state = 'seekRewinding'
            this.player.seek(videoOffset)
            return
        }
        if(this.state === 'seekRewinding' && Math.abs(videoPositionSeconds-videoOffset) < 3) {
            this.state = 'ready'
            this.player.pause()
            return
        }
        if(videoPositionSeconds > videoEnd) {
            this.state = 'seekRewind'
            return
        }
    },
    
    start() {
        this.playIntent = true
        if(!this.player) {
            this.load(true)
        }
        if(!this.player) {
            return
        }
        if(videoOffset > 0) {
            this.state = 'seekBegin'
        } else {
            this.state = 'ready'
        }
        this.playIntent = false
        this.player.play()
    },

    stop() {
        if(!this.player) {
            return
        }
        this.player.pause()
    }

}))